"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalParameterDefinition = void 0;
const parameter_types_1 = require("./parameter-types");
class OptionalParameterDefinition {
}
exports.OptionalParameterDefinition = OptionalParameterDefinition;
OptionalParameterDefinition.String = {
    type: parameter_types_1.ParameterTypes.String,
    optional: true
};
OptionalParameterDefinition.StringArray = {
    type: parameter_types_1.ParameterTypes.StringArray,
    optional: true
};
OptionalParameterDefinition.Boolean = {
    type: parameter_types_1.ParameterTypes.Boolean,
    optional: true
};
OptionalParameterDefinition.BooleanArray = {
    type: parameter_types_1.ParameterTypes.BooleanArray,
    optional: true
};
OptionalParameterDefinition.Number = {
    type: parameter_types_1.ParameterTypes.Number,
    optional: true
};
OptionalParameterDefinition.NumberArray = {
    type: parameter_types_1.ParameterTypes.NumberArray,
    optional: true
};
OptionalParameterDefinition.Date = {
    type: parameter_types_1.ParameterTypes.Date,
    optional: true
};
OptionalParameterDefinition.DateArray = {
    type: parameter_types_1.ParameterTypes.DateArray,
    optional: true
};
